







































































import Vue from 'vue';
import NOC from '@/class/common/const';

export default Vue.extend({
  name: 'QuitLoginModal',
  props: {
    display: String,
  },
  data() {
    return {
      exclamationImgUrl: '/images/exclamation.png',
    };
  },
  computed: {
    TRIAL(): boolean {
      return this.display === NOC.CONTRACT.TRIAL;
    },
    QUIT(): boolean {
      return this.display === NOC.CONTRACT.QUIT;
    },
    CONFIRM(): boolean {
      return this.display === NOC.CONTRACT.CONFIRM;
    },
    DENY(): boolean {
      return this.display === NOC.CONTRACT.DENY;
    },
  },
});
